const preventDefault = (e: React.SyntheticEvent | Event) => {
  if (e.cancelable) {
    e.preventDefault();
  }
};
export default preventDefault;
